import React from 'react';

const MAP = {
  online: { color: '#34d399', label: 'Online', pulse: true },
  degraded: { color: '#fbbf24', label: 'Degraded', pulse: true },
  offline: { color: '#FF5C7A', label: 'Offline', pulse: false },
  unconfigured: { color: '#7F8FB3', label: 'No URL', pulse: false },
  checking: { color: '#7F8FB3', label: 'Checking…', pulse: true },
};

export function HealthDot({ status = 'checking', latency, showLabel = false, size = 8 }) {
  const s = MAP[status] || MAP.checking;
  const title = s.label + (latency != null ? ` · ${latency}ms` : '');
  return (
    <span className="inline-flex items-center gap-1.5" title={title} data-testid="health-dot" data-status={status}>
      <span className="relative inline-flex" style={{ width: size, height: size }}>
        {s.pulse && (
          <span className="absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping" style={{ background: s.color }} />
        )}
        <span className="relative inline-flex rounded-full" style={{ width: size, height: size, background: s.color }} />
      </span>
      {showLabel && <span className="text-xs font-medium" style={{ color: s.color }}>{s.label}</span>}
    </span>
  );
}
